import React, { useCallback, useEffect, useState } from 'react'
import classnames from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import Window from 'components/dialog/Window'
import Loading from 'components/system/Loading'

import authSelectors from 'store/selectors/auth'
import uiSelectors from 'store/selectors/ui'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import adminActions from 'store/modules/admin'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0),
  },  
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'fixed',
    zIndex: 100,
  },
  tabPaper: {
    flexGrow: 1,
  },
  content: {
    padding: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  tabContent: {
    paddingTop: theme.spacing(8),
  }
}))

const BookingFormLayout = ({
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [ projectLoaded, setProjectLoaded ] = useState(false)

  const {
    id,
  } = useSelector(routerSelectors.params)

  const adminTabs = useSelector(uiSelectors.adminTabs)
  const segments = useSelector(routerSelectors.segments)
  const tabIndex = adminTabs.findIndex(tab => tab.id == segments[segments.length-1])
  const setTab = useCallback((ev, tabIndex) => {
    const tabInfo = adminTabs[tabIndex]
    dispatch(routerActions.navigateTo(`admin.bookingforms.edit.${tabInfo.id}`, Object.assign({}, tabInfo.params, {
      id,
    })))
  }, [
    adminTabs,
    id,
  ])

  useEffect(() => {
    const runAsync = async () => {
      setProjectLoaded(false)
      const result = await dispatch(adminActions.ensureBookingFormProject({
        id,
      }))
      if(result) setProjectLoaded(true)
    }
    runAsync()
  }, [
    id,
  ])

  if(!projectLoaded) {
    return (
      <Loading />
    )
  }

  return (
    <div className={ classes.root }>
      {
        tabIndex >= 0 && (
          <div className={ classes.toolbar }>
            <Paper square className={ classes.tabPaper }>
              <Tabs
                value={ tabIndex }
                onChange={ setTab }
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                {
                  adminTabs.map((tab, i) => {
                    return (
                      <Tab
                        key={ i }
                        label={ tab.title }
                        disabled={ id == 'new' && tab.id != 'config' }
                      />
                    )
                  })
                }
              </Tabs>
            </Paper>
          </div>
        )
      }
      <div className={classnames(classes.content, {
        [classes.tabContent]: tabIndex >= 0,
      })}>
        { children }
      </div>
    </div>
  )
}

export default BookingFormLayout